import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const AssessmentProperties: IProperty[] = [
    { id: Property.CancelPageLink, name: 'Navigate', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]
